(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('amelise-cart-offer')) {
    class AmeliseCartOffer extends HTMLElement {
      connectedCallback() {
        this.updateTimer();
        this.timer = window.setInterval(() => this.updateTimer(), 1000);
      }

      disconnectedCallback() {
        if (this.timer) window.clearInterval(this.timer);
      }

      updateTimer() {
        const now = new Date();
        const end = new Date(now);
        end.setHours(23, 59, 59, 999);

        const remaining = Math.max(0, end.getTime() - now.getTime());
        const hours = Math.floor(remaining / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        const hoursElement = this.querySelector('[data-ab-hours]');
        const minutesElement = this.querySelector('[data-ab-minutes]');
        const secondsElement = this.querySelector('[data-ab-seconds]');

        if (hoursElement) hoursElement.textContent = String(hours).padStart(2, '0');
        if (minutesElement) minutesElement.textContent = String(minutes).padStart(2, '0');
        if (secondsElement) secondsElement.textContent = String(seconds).padStart(2, '0');
      }
    }

    customElements.define('amelise-cart-offer', AmeliseCartOffer);
  }

  } catch(e) { console.error(e); }
})();
})();
